import React from "react";

const WufooIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_917)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.00927734 20.6183C0.335996 31.3778 9.16115 40 19.9999 40C31.0455 40 39.9999 31.0456 39.9999 20C39.9999 8.95437 31.0455 0 19.9999 0C9.16115 0 0.335996 8.62219 0.00927734 19.3817V20.6183Z",
  fill: "#E66760"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.3968 32.3351L3.80493 13.3134L10.3388 11.2417L15.4185 22.6162L16.1157 10.4051L21.7931 9.30935L27.0321 20.4847L27.5029 8.2081L33.3468 7.05841L31.6736 28.7915L25.5579 30.0067L20.2792 19.0704L19.5421 31.2019L13.3968 32.3351Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_917"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(WufooIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;